import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './_guards/auth.guard';
import { TicketsComponent } from './tickets/tickets.component';

const AppRoutes: Routes = [
  { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'tickets', component: TicketsComponent },
      // outras rotas filhos aqui
    ]
  },
  { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },
  // adicione outras rotas principais aqui
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, { useHash: true });


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts